type Props = { size?: number; style?: React.CSSProperties };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
});

export const IconCursor = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M5 3l6.5 16 2.2-6.3 6.3-2.2z" />
  </svg>
);

export const IconHand = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M9 11V5.5a1.5 1.5 0 013 0V11m0-1.5a1.5 1.5 0 013 0V12m0-1a1.5 1.5 0 013 0v4a5 5 0 01-5 5h-2.2a5 5 0 01-3.9-1.9L6 15.5a1.6 1.6 0 012.4-2L9 14V9.5a1.5 1.5 0 00-3 0" />
  </svg>
);

export const IconPen = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M4 20l4-1 10-10a2.1 2.1 0 00-3-3L5 16z" />
  </svg>
);

export const IconMarker = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M4 20h6l9-9a2.5 2.5 0 00-3.5-3.5l-9 9z" />
    <path d="M14 8l3 3" />
  </svg>
);

export const IconEraser = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M8 20H5l-1.5-1.5a2 2 0 010-3L13 6a2 2 0 013 0l3 3a2 2 0 010 3L11 20z" />
    <path d="M9 12l4 4" />
  </svg>
);

export const IconCheck = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="4" />
    <path d="M8 12.5l2.6 2.6L16 9.5" />
  </svg>
);

export const IconTimer = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <circle cx="12" cy="13.5" r="7.5" />
    <path d="M12 9.5v4l2.5 1.5M9.5 2.5h5" />
  </svg>
);

export const IconNote = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M4.5 4.5h15v10l-5 5h-10z" />
    <path d="M19.5 14.5h-5v5" />
  </svg>
);

export const IconText = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M5 6.5V5h14v1.5M12 5v14M9 19h6" />
  </svg>
);

export const IconCard = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <rect x="3.5" y="5" width="17" height="14" rx="3" />
    <path d="M3.5 10h17M7 14.5h5" />
  </svg>
);

export const IconTable = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="3" />
    <path d="M3.5 9.5h17M9.5 9.5v10M15 9.5v10" />
  </svg>
);

export const IconDiagram = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <rect x="8.5" y="2.5" width="7" height="5" rx="1.5" />
    <rect x="2.5" y="16.5" width="7" height="5" rx="1.5" />
    <rect x="14.5" y="16.5" width="7" height="5" rx="1.5" />
    <path d="M12 7.5v4M12 11.5H6v5M12 11.5h6v5" />
  </svg>
);

export const IconPlus = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconMinus = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M5 12h14" />
  </svg>
);

export const IconFit = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
  </svg>
);

export const IconSpotlight = ({ size = 18 }: Props) => (
  <svg {...base(size)}>
    <circle cx="12" cy="12" r="3.5" />
    <path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.2 5.2l1.8 1.8M17 17l1.8 1.8M18.8 5.2L17 7M7 17l-1.8 1.8" />
  </svg>
);

export const IconTrash = ({ size = 16 }: Props) => (
  <svg {...base(size)}>
    <path d="M4 6.5h16M9 6.5V4.5h6v2M6.5 6.5l1 13h9l1-13" />
  </svg>
);

export const IconChevron = ({ size = 14, style }: Props) => (
  <svg {...base(size)} style={style}>
    <path d="M9 5l7 7-7 7" />
  </svg>
);

export const IconBoards = ({ size = 16 }: Props) => (
  <svg {...base(size)}>
    <rect x="3.5" y="3.5" width="7" height="7" rx="2" />
    <rect x="13.5" y="3.5" width="7" height="7" rx="2" />
    <rect x="3.5" y="13.5" width="7" height="7" rx="2" />
    <rect x="13.5" y="13.5" width="7" height="7" rx="2" />
  </svg>
);

export const IconSpark = ({ size = 18 }: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.2l1.9 5.6a4 4 0 002.3 2.4l5.6 1.8-5.6 1.9a4 4 0 00-2.3 2.3L12 21.8l-1.9-5.6a4 4 0 00-2.3-2.3L2.2 12l5.6-1.8a4 4 0 002.3-2.4z" />
  </svg>
);

export const IconLockOpen = ({ size = 16 }: Props) => (
  <svg {...base(size)}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
    <path d="M8 10.5V7a4 4 0 017.7-1.4" />
  </svg>
);

export const IconShare = ({ size = 16 }: Props) => (
  <svg {...base(size)}>
    <path d="M12 15V4m0 0L8 8m4-4l4 4" />
    <path d="M4.5 14v4.5a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5V14" />
  </svg>
);
